import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState,
} from "react";
import _, { Dictionary } from "lodash";
import { SwipeAction, Toast } from "antd-mobile";
import { Description } from "../schema";
import { useUpdateEffect } from "react-use";
import GridItem from "./GridItem";

interface GridProps {
  descriptions: Description[];
  mobileTitle?: { [name: string]: string };
  data?: { [key: string]: any };
  type?: string;
  groupable?: boolean;
  swipeActionable?: boolean;
  hidden?: {
    [key: string]: boolean;
  };
  onChange: (
    value: { [key: string]: any },
    hidden?: {
      //用户删除的字段
      [key: string]: boolean;
    }
  ) => void;
}

export default forwardRef(
  (
    {
      descriptions,
      mobileTitle,
      type,
      groupable = false,
      hidden = {},
      onChange,
      data = {},
      swipeActionable = true,
    }: GridProps,
    ref: any
  ) => {
    const [internalData, setInternalData] = useState<{ [key: string]: any }>(
      data
    );
    const [dataError, setDataError] = useState<{ [key: string]: boolean }>();
    const [dataHiddenStatus, setDataHiddenStatus] = useState<{
      [key: string]: boolean;
    }>(hidden);
    const descriptionGroups: Dictionary<Description[]> = useMemo(() => {
      descriptions.forEach((description) => {
        setDataError((prevState) => {
          if (prevState === undefined)
            return { [description.fieldName]: false };
          return { ...prevState, [description.fieldName]: false };
        });
        setDataHiddenStatus((prevState) => {
          if (prevState === undefined)
            return { [description.fieldName]: false };
          if (prevState[description.fieldName] === undefined)
            return { ...prevState, [description.fieldName]: false };
          else return { ...prevState };
        });
      });

      return _.groupBy(descriptions, (item: Description) => item.classify);
    }, [descriptions]);
    const handleInputItemChange = useMemo(() => {
      const result: { [key: string]: (value: any) => void } = {};
      for (const name of Object.keys(descriptionGroups)) {
        const descriptionGroup = descriptionGroups[name];
        for (const description of descriptionGroup) {
          result[description.fieldName] = (value) => {
            setDataError((prevState) => {
              if (prevState === undefined) return prevState;
              const cloned = { ...prevState };
              cloned[description.fieldName] = false;
              return cloned;
            });
            setInternalData((prevState) => {
              return {
                ...prevState,
                [description.fieldName]: value,
              };
            });
          };
        }
      }
      return result;
    }, [descriptionGroups]);

    // useEffect(() => {
    //   if (JSON.stringify(data) !== "{}") {
    //     console.log(data, 9999999999);
    //     setInternalData(data);
    //   }
    // }, [data]);

    useUpdateEffect(() => {
      onChange(internalData, dataHiddenStatus);
    }, [internalData, dataHiddenStatus]);

    useImperativeHandle(ref, () => ({
      validate: () => {
        let flag = true;
        const errorFieldShowNames = [];
        for (const name of Object.keys(descriptionGroups)) {
          const descriptionGroup = descriptionGroups[name];
          for (const description of descriptionGroup) {
            if (
              description.required &&
              (internalData[description.fieldName] === undefined ||
                internalData[description.fieldName] === "")
            ) {
              console.log(description.fieldShowName);
              errorFieldShowNames.push(description.fieldShowName);
              setDataError((prevState) => {
                if (prevState === undefined) return prevState;
                const cloned = { ...prevState };
                cloned[description.fieldName] = true;
                console.log(cloned);
                return cloned;
              });
              flag = false;
            }
          }
        }
        return { flag: flag, errorFieldShowNames: errorFieldShowNames };
      },
      dataHiddenStatus: () => {
        const cloned = { ...dataHiddenStatus };
        for (const i of Object.keys(cloned)) {
          if (!cloned[i]) delete cloned[i];
        }
        if (Object.keys(cloned).length === 0) return undefined;
        return cloned;
      },
      // hidden: (fieldHidden: any) => {
      //   console.log(fieldHidden);
      //   descriptions.forEach((description) => {
      //     // return { ...prevState, [description.fieldName]: false };
      //     debugger;
      //     setDataHiddenStatus((prevState) => {
      //       const cloned = { ...prevState };
      //       let flag = true;
      //       debugger;
      //       for (const fieldHiddenName of Object.keys(fieldHidden)) {
      //         if (description.fieldName === fieldHiddenName) {
      //           flag = false;
      //           console.log(cloned[fieldHiddenName]);
      //           console.log(fieldHidden[fieldHiddenName]);
      //           cloned[fieldHiddenName] = fieldHidden[fieldHiddenName];
      //         } else {
      //           console.log(description.fieldName);
      //         }
      //       }
      //       if (flag) {
      //         //该字段并没隐藏，直接赋值
      //         return { ...prevState, [description.fieldName]: false };
      //         // cloned[description.fieldName] = false;
      //       }
      //       console.log(prevState);
      //       console.log(cloned);
      //       return cloned;
      //     });
      //   });
      // },
      show: (fieldShow: any) => {
        if (fieldShow === undefined) return;
        fieldShow.map((name: any) =>
          setDataHiddenStatus((prevState) => {
            const cloned = { ...prevState };
            cloned[name.name] = false;
            return cloned;
          })
        );
      },
    }));

    return (
      <>
        {Object.keys(descriptionGroups).map((name: string, index: number) => (
          <>
            {groupable && <div className="classifyName">{name}</div>}
            {descriptionGroups[name].map((description) => (
              <SwipeAction
                disabled={type === "detail"}
                key={`swipeAction_${description.fieldName}`}
                autoClose
                right={
                  swipeActionable
                    ? [
                        {
                          text: "删除",
                          onPress: () => {
                            if (description.required)
                              Toast.info("该项为必填项,不允许删除", 1);
                            else {
                              //字段隐藏
                              setDataHiddenStatus((prevState) => {
                                const cloned = { ...prevState };
                                cloned[description.fieldName] = true;
                                return cloned;
                              });
                              //字段删除,清空内容
                              setInternalData((prevState) => {
                                prevState[description.fieldName] = undefined;
                                return prevState;
                              });
                            }
                          },
                          style: { backgroundColor: "#FF0000", color: "white" },
                        },
                      ]
                    : []
                }>
                <GridItem
                  description={description}
                  mobileTitle={mobileTitle?.[description.fieldName]}
                  defaultValue={internalData[description.fieldName]}
                  error={false}
                  hidden={false}
                  onChange={handleInputItemChange[description.fieldName]}
                />
              </SwipeAction>
            ))}
            {/* </List> */}
          </>
        ))}
      </>
    );
  }
);
